import React from 'react'

import styles from './CommunityBillingPopup.module.scss'
import { ReactComponent as CloseIcon } from 'assets/img/close.svg';
import PerfectScrollbar from 'react-perfect-scrollbar';
import GAModal from 'elements/GAModal/GAModal';

const CommunityBillingPopup = (
    {
        dialogID,
        closefn,
        titleText,
        DialogWidth,
        IsOpen,
        childrenComponents,
    }:
        {
            dialogID: string
            closefn: any
            titleText: string
            DialogWidth?: string
            IsOpen: boolean
            childrenComponents: JSX.Element
        }
) => {
    const [childElements, setChildElements] = React.useState(childrenComponents);

    React.useEffect(() => {
        if (IsOpen) {
            setChildElements(childrenComponents); // Reload children when modal opens
        }
    }, [IsOpen, childrenComponents]);

    return (
        <GAModal
            isOpen={IsOpen}
            toggle={closefn} size={"auto"}
        >
            <PerfectScrollbar
                className={styles.CommunityBillingPopupBody}
                options={{ wheelPropagation: true }}
            >
                <div className={styles.CommunityBillingPopupHeader}>
                    <h1>{titleText} </h1>
                    <span onClick={closefn}>
                        <CloseIcon />
                    </span>
                </div>
                {childElements}
            </PerfectScrollbar>
        </GAModal>
    )
}

export default CommunityBillingPopup